(ns frontend.view.reports.custom.alj-2.total-deals-charts
  (:require
   [clojure.set :as set]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]))


(defn total-deals
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:oppo.status/ok} [:oppo.status/ok :oppo.status/passed :oppo.status/portfolio]]
                          [:date-passed #{:oppo.status/passed} [:oppo.status/ok :oppo.status/passed :oppo.status/portfolio]]
                          [:date-portfolio #{:oppo.status/portfolio} [:oppo.status/ok :oppo.status/passed :oppo.status/portfolio]]])]
    (fn [{:keys [state]}]
      (let [all-deals (alj/all-deals)
            passed-deals (->> all-deals
                              (cu/filter-by :oppo/status :oppo.status/passed)
                              (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :oppo.status/passed)
                              (alj-utils/deals-in-date-range-if-configured :oppo/passed-on @date-state-atom :date-passed :oppo.status/passed)
                              (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :oppo.status/passed))
            portfolio-deals (->> all-deals
                                 (cu/filter-by :oppo/status :oppo.status/portfolio)
                                 (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :oppo.status/portfolio)
                                 (alj-utils/deals-in-date-range-if-configured :oppo/passed-on @date-state-atom :date-passed :oppo.status/portfolio)
                                 (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom
                                                                              :date-portfolio :oppo.status/portfolio))
            active-deals (->> all-deals
                              (cu/filter-by :oppo/status :oppo.status/ok)
                              (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :oppo.status/ok)
                              (alj-utils/deals-in-date-range-if-configured :oppo/passed-on @date-state-atom :date-passed :oppo.status/ok)
                              (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :oppo.status/ok))

            filtered-deals (concat passed-deals
                                    portfolio-deals
                                    active-deals)

            deals-by-status (->> filtered-deals
                                 (group-by :oppo/status))
            series-1 {:name  "ALJ Ticket Size $M"
                      :type  "column"
                      ;:colorByPoint true
                      :color alj/primary-color
                      :data  (->> deals-by-status
                                  (map (fn [[status oppos]]
                                         (let [alj-investment-sum (alj-utils/ticket-size-sum-millions oppos)]
                                           {:name       (loc/tr status)
                                            :y          alj-investment-sum
                                            :dataLabels {:formatter alj-utils/million-format-with-separators}
                                            :drilldown  (str status)})))
                                  (vec))}

            series-2 {:name  "Count of Deals"
                      :type  "column"
                      ;:colorByPoint true
                      :color "lightgrey"
                      :data  (->> deals-by-status
                                  (map (fn [[status oppos]]
                                         {:name      (loc/tr status)
                                          :y         (count oppos)
                                          :drilldown (loc/tr status)}))
                                  (vec))}

            categories (->> deals-by-status
                            (mapv (fn [[status _]]
                                    (loc/tr status))))

            chart-data {:series [series-1 series-2]
                        :xAxis  [{:categories categories}]}

            export-data (->> chart-data
                             :series
                             (first)
                             :data
                             (map (fn [{:keys [name y]}]
                                    [name y]))
                             (sort-by first)
                             (doall))
            view-name "Total deals"]
        [alj-components/vertical-bar-chart
         {:view-name       view-name
          :total-deals     (count filtered-deals)
          :total-amount    (alj-utils/ticket-size-sum-billions filtered-deals)
          :report-data     export-data
          :chart-data      chart-data
          :date-state-atom date-state-atom}]))))


(defn total-deals-by-deal-type
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{} [:entity.type/oppo]]
                          [:date-passed #{:oppo.status/passed} [:entity.type/oppo]]
                          [:date-portfolio #{:oppo.status/portfolio} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/passed-on @date-state-atom :date-passed :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :entity.type/oppo))
            used-deal-types (->> deals
                                 (mapcat :oppo/tag-deal-type)
                                 (frequencies)
                                 (sort-by second)
                                 (reverse)
                                 (keep (fn [[eid nof]]
                                         (let [entity (get @session/entities eid)]
                                           (when-not (:common/disabled? entity)
                                             entity))))
                                 (doall))
            active-deal-type-ids (->> (session/non-archived-named-values :oppo/tag-deal-type (alj/alj-report-pipeline-id))
                                      (map :db/id)
                                      (set))
            deals-wo-active-dea-type? (->> deals
                                           (some (fn [oppo]
                                                   (empty? (set/difference (set (:oppo/tag-deal-type oppo)) active-deal-type-ids)))))

            show-deal-types-num 4

            shown-deal-types (take show-deal-types-num used-deal-types)

            shown-deal-type-ids (mapv :db/id shown-deal-types)

            other-deal-types (drop show-deal-types-num used-deal-types)

            other-deal-type-ids (mapv :db/id other-deal-types)

            series-1 {:name    "ALJ Ticket Size ($M)"
                      :type    "column"
                      :tooltip {:valueSuffix "M"
                                :valuePrefix "$"}
                      :color   "#51859A"
                      :data    (vec
                                (concat
                                 (->> shown-deal-types
                                      (map (fn [named-value]
                                             (let [named-value-label (:named-value/value named-value)
                                                   deals-w-type (->> deals
                                                                     (filterv (fn [deal]
                                                                                (some #{(:db/id named-value)}
                                                                                      (:oppo/tag-deal-type deal)))))
                                                   ticket-size-sum (alj-utils/ticket-size-sum-millions deals-w-type)]
                                               {:name       named-value-label
                                                :y          ticket-size-sum
                                                :dataLabels {:formatter alj-utils/million-format-with-separators
                                                             :style     {:textOutline 0
                                                                         :fontFamily  "Arial"
                                                                         :fontSize    "10px"}}
                                                :drilldown  (str named-value-label)}))))
                                 (let [deals-with-other (->> deals
                                                             (remove (fn [deal]
                                                                       (let [deal-types (:oppo/tag-deal-type deal)]
                                                                         (and deal-types
                                                                              (some (:oppo/tag-deal-type deal)
                                                                                    shown-deal-type-ids))))))
                                       ticket-size-sum (->> deals-with-other
                                                            (map :oppo/cur-ticket)
                                                            (mapv fu/bigdec->float)
                                                            (apply +))

                                       ticket-size-sum (/ ticket-size-sum 1000000)]
                                   (when (seq deals-with-other)
                                     [{:name       "Other"
                                       :y          ticket-size-sum
                                       :dataLabels {:formatter alj-utils/million-format-with-separators
                                                    :style     {:textOutline 0
                                                                :fontFamily  "Arial"
                                                                :fontSize    "10px"}}
                                       :drilldown  "Other"}]))))}

            series-2 {:name  "Count of Deals"
                      :type  "line"
                      :color "lightgrey"
                      :yAxis 1
                      :data  (vec
                              (concat
                               (->> shown-deal-types
                                    (map (fn [named-value]
                                           (let [named-value-label (:named-value/value named-value)
                                                 deals-w-type (->> deals
                                                                   (filterv (fn [deal]
                                                                              (some #{(:db/id named-value)}
                                                                                    (:oppo/tag-deal-type deal)))))]
                                             {:name      named-value-label
                                              :y         (count deals-w-type)
                                              :drilldown (str named-value-label)})))
                                    (vec))
                               (let [deals-with-other (->> deals
                                                           (remove (fn [deal]
                                                                     (let [deal-types (:oppo/tag-deal-type deal)]
                                                                       (and deal-types
                                                                            (some (:oppo/tag-deal-type deal)
                                                                                  shown-deal-type-ids))))))]
                                 (when (seq deals-with-other)
                                   [{:name      "Other"
                                     :y         (count deals-with-other)
                                     :drilldown "Other"}]))))}


            categories (vec
                        (concat (->> shown-deal-types
                                     (mapv (fn [{:keys [named-value/value]}]
                                             value)))
                                ["Other"]))


            chart-data {:series      [series-1 series-2]
                        :tooltip     {:headerFormat "<b>{point.name}</b><br/>"
                                      :pointFormat  "{point.name}: {point.y}"}
                        :plotOptions {:series [{:dataLabels {:enabled   false
                                                             :formatter alj-utils/million-format-with-separators}}
                                               {:dataLabels {:enabled true
                                                             :format  "{point.y}"}}]}

                        :xAxis       [{:categories categories}]

                        :yAxis       [{:labels {:format "{value}M"}
                                       :title  {:text "ALJ Ticket size"}}
                                      {:labels   {:format "{value}"}
                                       :title    {:text "Count of Deals"}
                                       :opposite true}]}

            export-data (->> chart-data
                             :series
                             (first)
                             :data
                             (map (fn [{:keys [name y]}]
                                    [name y]))
                             (sort-by first)
                             (doall))
            view-name "Total deals by deal type"]

        [alj-components/vertical-bar-chart
         {:view-name       view-name
          :total-deals     (count deals)
          :total-amount    (alj-utils/ticket-size-sum-billions deals)
          :report-data     export-data
          :chart-data      chart-data
          :date-state-atom date-state-atom}]))))

(defn total-deals-bu-and-value
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]
                          [:date-passed #{} [:entity.type/oppo]]
                          [:date-portfolio #{} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/passed-on @date-state-atom :date-passed :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :entity.type/oppo))]
        [alj-components/deals-by-business-unit
         {:deals           deals
          :view-name       "Total Deals by SBU - value $M"
          :x-axis-type     :ticket-size-sum
          :date-state-atom date-state-atom}]))))

(defn total-deals-bu-and-number-of-deals
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]
                          [:date-passed #{} [:entity.type/oppo]]
                          [:date-portfolio #{} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/passed-on @date-state-atom :date-passed :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :entity.type/oppo))]
        [alj-components/deals-by-business-unit
         {:deals           deals
          :view-name       "Total Deals by SBU - Count of Deals"
          :x-axis-type     :number-of-deals
          :date-state-atom date-state-atom}]))))
